import { useSelector } from "react-redux";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { RootState } from "../../state/store";
import { darkTheme, lightTheme } from "../../helpers/theme";
import { GlobalStyles } from "../../helpers/globalStyles";
import { useEffect, ReactNode } from "react";
import { updateTheme } from "../../state/features/theme/operations";

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const { theme } = useSelector((state: RootState) => state);

  // Apply Bootstrap theme attribute
  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme.mode);
    
    // Store theme preference in localStorage
    localStorage.setItem("preferred-theme", theme.mode);
  }, [theme.mode]);

  // Load theme preference on initial load
  useEffect(() => {
    const savedTheme = localStorage.getItem("preferred-theme");
    if (savedTheme && (savedTheme === "light" || savedTheme === "dark")) {
      updateTheme(savedTheme);
    } else {
      // Check for system preference if no saved theme
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      updateTheme(prefersDark ? "dark" : "light");
    }
  }, []);

  return (
    <SCThemeProvider theme={theme.mode === "light" ? lightTheme : darkTheme}>
      <GlobalStyles />
      {children}
    </SCThemeProvider>
  );
};

export default ThemeProvider;
